const PageInfo = ({ page }) => {
  const base_url = process.env.PUBLIC_URL;
  return (
    <>
      <div className="step-header" style={{ backgroundColor: `${page.color}`, background: `${page.color}` }}>
        <div className="step-header-wrapper">
          <h2 className="info-title">{page.title}</h2>
          <div className="info-text" dangerouslySetInnerHTML={{ __html: page.content }}></div>
        </div>
      </div>

      <div className="step-footer"></div>
    </>
  );
};

export default PageInfo;
